// Action Types
export const FETCH_AUTO_NURTURE_REQUEST = "FETCH_AUTO_NURTURE_REQUEST";
export const FETCH_AUTO_NURTURE_SUCCESS = "FETCH_AUTO_NURTURE_SUCCESS";
export const FETCH_AUTO_NURTURE_FAILURE = "FETCH_AUTO_NURTURE_FAILURE";
export const UPDATE_AUTO_NURTURE_STAT = "UPDATE_AUTO_NURTURE_STAT";


// Action Creators
export const FetchAutoNurtureRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_AUTO_NURTURE_REQUEST,
      payload: { clientName, accountName, userId, type },
    });
  };
};
export const FetchAutoNurtureSuccess = (data) => ({
  type: FETCH_AUTO_NURTURE_SUCCESS,
  payload: data,
});
export const FetchAutoNurtureFailure = (error) => ({
  type: FETCH_AUTO_NURTURE_FAILURE,
  payload: error,
});
export const updateAutoNurtureStatus = (campId,activeStatus) => ({
  type: UPDATE_AUTO_NURTURE_STAT,
  payload: {campId,activeStatus},
});